import React, {useState, useEffect, useCallback} from 'react';
import LinkHook from "./linkHook";
import ImgHook from "./imgHook";
import ImgLinkHook from "./imgLinkHook";
import TextHook from "./textHook";
import './dataHook.css'

const DataHook = (props) => {
    const hooks = props.hooks
    //Get the position of the hook on the store locator
    const currentHookPosition = hooks ? hooks.filter((e,i) => e.position.indexOf(props.position) > -1) : false

    /**
     * Get hook by id
     * @param id id of the hook
     * @returns {*|boolean}
     */
    const getById = (id) => {
        let gettedElement  = currentHookPosition.filter((e,i) => e.id === id)
        return gettedElement.length !== 0 ? gettedElement : false
    }

    /**
     * Return component by hook type
     * @param e hook element
     * @param ce hook element content
     * @returns {JSX.Element|null}
     */
    const hookType = (e,ce) => {
        switch (e.type){
            case 'link':
                return (
                    <LinkHook
                        href={ce.href}
                        target={ce.target ? ce.target : '_blank'}
                        text={ce.text}
                        className={'single-link'}
                    />
                )
            case 'text':
                return (
                    <TextHook
                        text={ce.text}
                    />
                )
            case 'img':
                return (
                    <ImgHook
                        imgUrl={ce.img_url}
                        width={ce.img_width ? ce.img_width : 50}
                        height={ce.img_height ? ce.img_height : 50} href={ce.href ? ce.href : ''}
                    />
                )
            case 'imgLink':
                return (
                    <ImgLinkHook
                        className={'image-link'}
                        target={ce.target ? ce.target : '_blank'}
                        width={ce.img_width ? ce.img_width : 50}
                        height={ce.img_height ? ce.img_height : 50} href={ce.href ? ce.href : ''}
                        imgUrl={ce.img_url ? ce.img_url : ''}
                    />
                )
            default:
                return null;
        }
    }
    return (
        <>
            {currentHookPosition ?
                currentHookPosition.map((e,i) => {

                    const assoc = e.assoc ? getById(e.assoc) : false

                    return (
                        !assoc || assoc[0].content ?
                            <div key={`hookedItem-${i}`} className={`appended-item ${e.side === 'right' ? 'appended-item-right' : ''} ${e.side === 'center' ? 'appended-item-center' : ''}`}>
                                {e.content ?
                                    e.content.map((ce,ci) => {
                                        return(
                                            <div key={`appendedObject-${ci}`} className={'appended-item-object'}>
                                                {hookType(e,ce,ci)}
                                            </div>
                                        )
                                    })
                                    : ''
                                }
                            </div> : ''

                );
                })
                :
                ''
            }
        </>
    );
}

export default DataHook